export const status = {
  label: 'Status',
  key: 'status',
  icon: 'pulse',
  tooltip: 'Filter transfers by status.',
  options: [{
    value: 'pending',
    label: 'Pending'
  }]
}
